<script setup lang="ts">
import InterviewHeader from '../../../interview/components/dumb/InterviewHeader.vue'
import InterviewLayout from '../../../interview/components/dumb/InterviewLayout.vue'
import { c } from '../../../intl'

const props = defineProps<{
  brandImage: string | null
}>()
</script>
<template>
  <InterviewLayout v-if="brandImage">
    <template #header>
      <InterviewHeader :brand-image="props.brandImage" title="INTRO" />
    </template>
    <h1 class="thank-you">
      {{ c('interview_page.thank_you') }}
    </h1>
  </InterviewLayout>
  <h1 v-else class="thank-you">
    {{ c('interview_page.thank_you') }}
  </h1>
</template>
<style lang="postcss">
.thank-you {
  color: #036;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bolder;
  padding: var(--attest-spacing-8);
  text-align: center;
}
</style>
